import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {UserRegion} from './user.model';
import {environment} from '../../../environments/environment';
import {tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserRegionService {

  private userRegionsLoaded = false;
  private userRegionsSub: BehaviorSubject<UserRegion[]> = new BehaviorSubject([]);
  private userRegions$ = this.userRegionsSub.asObservable();

  constructor(private readonly httpClient: HttpClient) {}

  getUserRegions(): Observable<UserRegion[]> {
    if (this.userRegionsLoaded) {
      return this.userRegions$;
    }
    return this.httpClient.get<UserRegion[]>(`${environment.baseUrl}users/regions`)
      .pipe(
        tap(() => this.userRegionsLoaded = true),
        tap(regions => this.userRegionsSub.next(regions)),
      );
  }
}
